// extracted by mini-css-extract-plugin
module.exports = {"up":"chevron_up__sYhKB","down":"chevron_down__X5Nb1","left":"chevron_left__JS9Y0"};